module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-body__wrap"
  }, [_c('div', {
    staticClass: "cb-body__content"
  }, [_c('div', {
    staticClass: "cb-section"
  }, [(_vm.agreements) ? _c('div', {
    staticClass: "cb-note cb-note--left cb-note--align cb-note--fw"
  }, [_c('div', {
    staticClass: "cb-note__content"
  }, [_vm._l((_vm.agreements), function(value, key) {
    return [_c('div', {
      directives: [{
        name: "cb-html",
        rawName: "v-cb-html",
        value: (value),
        expression: "value"
      }],
      key: key,
      staticClass: "cb-note__p"
    })]
  })], 2)]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de83a56e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/hosted-pages/payment-methods/direct-debit/GocardlessBacsGuarantee.vue
// module id = 156
// module chunks = 16 65 66 68